export default "__VITE_ASSET__D_P2HYcn__"